import globalConfig from '../../utiles/globalConfig';

// 代金幣入口配置
const INSERT_GAME_CURRENCY_INFO = {
  275: {
    name: '代金幣',
    descript: '可購買遊戲內所有商品',
    tag: '代金幣加碼20%',
    img: 'https://gimages.blancozone.com/aws_s3/img?s=/platform/one_image/2022/11/1668392208749.png',
    local: 'TW',
    f_pay_type: 'virtual_account',
    pay_type: 'virtual_account'
  }
};

// 訂單頁獲取渠道列表的時候，把非指定渠道都去掉
export const filterGamCurrencyPayType = (list, gameId, local) => {
  if (
    INSERT_GAME_CURRENCY_INFO[gameId] &&
    local == INSERT_GAME_CURRENCY_INFO[gameId].local &&
    globalConfig.getHrefParam('isCurrency') == 1
  ) {
    let _list = list.filter(
      item =>
        item?.f_pay_type == INSERT_GAME_CURRENCY_INFO[gameId]?.f_pay_type &&
        item?.pay_type == INSERT_GAME_CURRENCY_INFO[gameId]?.pay_type
    );
    return _list;
  }
  return list;
};

// 訂單頁過濾其他地區
export const filterLocal = (list, gameId, local) => {
  if (
    INSERT_GAME_CURRENCY_INFO[gameId] &&
    local == INSERT_GAME_CURRENCY_INFO[gameId].local &&
    globalConfig.getHrefParam('isCurrency') == 1
  ) {
    return {
      [INSERT_GAME_CURRENCY_INFO[gameId].local]:
        list[INSERT_GAME_CURRENCY_INFO[gameId].local]
    };
  }
  return list;
};

// 訂單頁修改商品名
export const updateProductInfo = (produce, gameId, local) => {
  if (
    INSERT_GAME_CURRENCY_INFO[gameId] &&
    local == INSERT_GAME_CURRENCY_INFO[gameId].local &&
    globalConfig.getHrefParam('isCurrency') == 1
  ) {
    (produce.IS_CURRENCY = 1),
      (produce.CP_PRODUCT_DESC = INSERT_GAME_CURRENCY_INFO[gameId].name),
      (produce.PRODUCT_ICON = INSERT_GAME_CURRENCY_INFO[gameId].img),
      (produce.GAME_AMOUNT = INSERT_GAME_CURRENCY_INFO[gameId].descript),
      (produce.PRODUCT_TAG = INSERT_GAME_CURRENCY_INFO[gameId].tag);
  }
};

// web端儲值頁，商品列表插入一個代金幣商品
export const insertCurrency = (list, allList, gameId, local, productTypes) => {
  if (
    INSERT_GAME_CURRENCY_INFO[gameId] &&
    INSERT_GAME_CURRENCY_INFO[gameId].local == local
  ) {
    // 防止篩選的時候沒有選中的商品，就用所有商品的第一個
    let _productItem =
      ((list[0] || allList[0]) &&
        JSON.parse(JSON.stringify(list[0] || allList[0]))) ||
      {};
    productTypes.forEach(item => {
      list.unshift({
        ..._productItem,
        IS_CURRENCY: 1,
        CP_PRODUCT_DESC: INSERT_GAME_CURRENCY_INFO[gameId].name,
        PRODUCT_ICON: INSERT_GAME_CURRENCY_INFO[gameId].img,
        GAME_AMOUNT: INSERT_GAME_CURRENCY_INFO[gameId].descript,
        PRODUCT_TYPE: item,
        PRODUCT_TAG: INSERT_GAME_CURRENCY_INFO[gameId].tag
      });
    });
  }
};
